export default class Base {
  constructor(api) {
    this.api = api
  }
}
